import { addAppInfoToUiGuideGroups } from 'console/ui-guide/steps/converter';
import { select_device_by_appliance_type } from 'console/redux/selectors';
import { is_current_device_has_valid_appliance, select_ui_guide_by_id, } from 'console/ui-guide/suggestion/utils';
import { pickDevice } from 'console/redux/main-actions';
export const setTipIndex = (index, key) => ({
    type: 'SET_LEARNING_INDEX',
    index,
    key,
});
export const run_ui_learning = (key) => ({
    type: 'RUN_LEARNING',
    key,
});
export const stop_learning = () => ({
    type: 'STOP_LEARNING',
});
export const loadUiGuideGroups = () => async (dispatch, getState, { api }) => {
    dispatch({ type: 'UI_GUIDE_GROUPS__REQUEST' });
    try {
        const { ui_guide_groups } = await api.get_ui_guide_groups();
        // теперь надо дополнить подсказки с сервера информацией
        dispatch({
            type: 'UI_GUIDE_GROUPS__OK',
            data: addAppInfoToUiGuideGroups(ui_guide_groups),
        });
    }
    catch (error) {
        dispatch({
            type: 'UI_GUIDE_GROUPS__FAIL',
            error,
        });
    }
};
export const startUILearning = (key) => async (dispatch, getState) => {
    dispatch(run_ui_learning(key));
    const guide = select_ui_guide_by_id(getState(), key);
    const device_for_select = select_device_by_appliance_type(getState(), guide?.appliance_types ?? []);
    if (device_for_select !== null &&
        !is_current_device_has_valid_appliance(getState(), guide?.appliance_types ?? [])) {
        dispatch(pickDevice(device_for_select.id ?? null));
    }
    dispatch(loadUiGuideGroups());
};
export const rejectUiLearning = (id) => async (dispatch, getState, { api }) => {
    const data = { rejected: true, id };
    dispatch({
        type: 'CHANGE_UI_GUIDE_GROUP_STATUS',
        group_id: id,
        rejected: true,
        passed: false,
        skipped: false,
    });
    await api.set_status_for_guide(data);
};
export const skipUiLearning = (id) => async (dispatch, getState, { api }) => {
    const data = { skipped: true, id };
    dispatch({
        type: 'CHANGE_UI_GUIDE_GROUP_STATUS',
        group_id: id,
        skipped: true,
        rejected: false,
        passed: false,
    });
    await api.set_status_for_guide(data);
};
export const passUiLearning = (id) => async (dispatch, getState, { api }) => {
    const data = { passed: true, id };
    dispatch({
        type: 'CHANGE_UI_GUIDE_GROUP_STATUS',
        group_id: id,
        passed: true,
        skipped: false,
        rejected: false,
    });
    await api.set_status_for_guide(data);
};
export const initialStoreHelper = (store_helper) => ({
    type: 'INITIAL_STORE_HELPER',
    ...store_helper,
});
